export default __webpack_public_path__ + "static/media/rename.75f4bde3.svg";